<template>
  <div class="swiper-container swiper-container-horizontal noselect">
    <transition :name="currentSlide" mode="out-in">
      <div class="swiper-wrapper" v-if="showWeek">
        <div class="swiper-slide swiper-slide-active">
          <ul
            ref="swiperUL"
            @touchstart="touchStarted"
            @mousedown="touchStartedMouse"
            @touchend="touchEnded"
            @mouseup="touchEndedMouse"
          >
            <li
              v-for="week in weekArray"
              :key="week.date + '' + week.month + '' + week.year"
              @click="changeDate(week.year, week.month, week.date)"
            >
              <span>{{ week.week }}</span>
              <span
                class="day-num"
                :class="{
                  orange:
                    new Date().getFullYear() === week.year &&
                    new Date().getMonth() + 1 === week.month &&
                    new Date().getDate() === week.date,
                  active: week.active
                }"
                >{{ week.date }}</span
              >
              <div
                class="have-appointment-wrapper"
                v-if="
                  selectedProviderID &&
                    appointmentDates[selectedProviderID] &&
                    appointmentDates[selectedProviderID].indexOf(
                      formatDate({
                        dayOfMonth: week.date,
                        month: week.month - 1,
                        year: week.year
                      })
                    ) !== -1
                "
              >
                <span class="have-appointment"> </span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { dateAndTimeMixin } from "../../../mixins/dateAndTimeMixin";
import { mapMutations, mapGetters, mapActions } from "vuex";

export default {
  mixins: [dateAndTimeMixin],
  data() {
    return {
      currentSlide: "slide-right",
      xStart: 0,
      week: ["sun", "mon", "tue", "wed", "thu", "fri", "sat"]
    };
  },
  props: {
    currentDate: Number,
    currentMonth: Number,
    currentYear: Number
  },
  created() {
    this.getYearlyAppointments(new Date().getFullYear());
  },
  computed: {
    ...mapGetters({
      getSelectedDayOfMonth: "getSelectedDayOfMonth",
      getSelectedMonth: "getSelectedMonth",
      getSelectedYear: "getSelectedYear",
      showWeek: "getShowWeeks",
      appointmentDates: "getAppointmentDates",
      selectedProviderID: "getSelectedProviderID"
    }),
    weekArray() {
      let weekArray = [];
      let date = new Date(
        this.currentYear,
        this.currentMonth,
        this.currentDate
      );
      let dayOfWeek = date.getDay();
      let startDate = this.currentDate - dayOfWeek;
      for (let i = 0; i < 7; i++) {
        let curDat = new Date(
          this.currentYear,
          this.currentMonth,
          startDate + i
        );
        weekArray.push({
          date: curDat.getDate(),
          year: curDat.getFullYear(),
          month: curDat.getMonth() + 1,
          week: this.week[i],
          active:
            this.getSelectedDayOfMonth === startDate + i &&
            this.getSelectedMonth === curDat.getMonth() &&
            this.getSelectedYear === curDat.getFullYear()
        });
      }

      return weekArray;
    }
  },
  methods: {
    ...mapMutations({
      setDayOfMonth: "setDayOfMonth",
      setMonth: "setMonth",
      setYear: "setYear",
      setWeek: "setWeek",
      setWeekMonth: "setWeekMonth",
      setWeekYear: "setWeekYear",
      toggleShowWeeks: "toggleShowWeeks"
    }),
    ...mapActions({
      getAppointmentDetails: "getAppointmentDetails",
      getYearlyAppointments: "getYearlyAppointments",
      toggleWeekAnimate: "toggleWeekAnimate"
    }),
    changeDate(year, month, date) {
      this.setDayOfMonth(date);
      this.setWeek(date);
      this.setMonth(month - 1);
      this.setYear(year);
      this.getAppointmentDetails();
    },
    touchStarted(event) {
      this.xStart = event.changedTouches[0].screenX;
    },
    touchEnded(event) {
      const diff = event.changedTouches[0].screenX - this.xStart;
      if (Math.abs(diff) > 50 && diff > 0) {
        // Go to previous week
        this.decreaseWeek();
      } else if (Math.abs(diff) > 50 && diff < 0) {
        // Go to next week
        this.increaseWeek();
      }
    },
    touchStartedMouse(event) {
      this.xStart = event.screenX;
    },
    touchEndedMouse(event) {
      const diff = event.screenX - this.xStart;
      if (Math.abs(diff) > 50 && diff > 0) {
        // Go to previous week
        this.decreaseWeek();
      } else if (Math.abs(diff) > 50 && diff < 0) {
        // Go to next week
        this.increaseWeek();
      }
    },
    increaseWeek() {
      // Step 1: Choose slide left as the animation, and set display to false, so that when display is set to true again, it will animate
      this.currentSlide = "slide-left";
      this.$nextTick(() => {
        this.toggleShowWeeks();

        // Step 2: Increase the week
        const nextWeek = new Date(
          this.currentYear,
          this.currentMonth,
          this.currentDate + 7
        );

        this.setWeek(nextWeek.getDate());
        this.setWeekMonth(nextWeek.getMonth());
        this.setWeekYear(nextWeek.getFullYear());

        this.toggleWeekAnimate();
      });
    },
    decreaseWeek() {
      // Step 1: Choose slide right as the animation, and set display to false, so that when display is set to true again, it will animate
      this.currentSlide = "slide-right";
      this.$nextTick(() => {
        this.toggleShowWeeks();

        // Step 2: Decrease the week
        const prevWeek = new Date(
          this.currentYear,
          this.currentMonth,
          this.currentDate - 7
        );

        this.setWeek(prevWeek.getDate());
        this.setWeekMonth(prevWeek.getMonth());
        this.setWeekYear(prevWeek.getFullYear());

        // Step 3: Show the week back again
        this.toggleWeekAnimate();
      });
    }
  }
};
</script>

<style scoped>
div {
  overflow: hidden !important;
  width: 100% !important;
  height: 58px !important;
}

div.swiper-container {
  text-align: center !important;
  height: 65px !important;
}

/* stage 2. Entered */
.slide-right-enter-active {
  animation: slide-in-right 0.2s ease-in-out forwards;
}

/* stage 3. leave */
.slide-right-leave-active {
  animation: slide-out-right 0.2s ease-in-out forwards;
}

.slide-right-move {
  transition: transform 0.2s ease-in-out;
}

.slide-left-enter-active {
  animation: slide-in-left 0.2s ease-in-out forwards;
}

/* stage 3. leave */
.slide-left-leave-active {
  animation: slide-out-left 0.2s ease-in-out forwards;
}

.slide-left-move {
  transition: transform 0.2s ease-in-out;
}

.orange {
  background-color: #d26d13;
  color: white;
}

@keyframes slide-in-right {
  from {
    transform: translateX(-20%);
    opacity: 0;
  }

  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slide-out-right {
  from {
    transform: translateX(0px);
    opacity: 1;
  }

  to {
    transform: translateX(20%);
    opacity: 0;
  }
}

@keyframes slide-in-left {
  from {
    transform: translateX(20%);
    opacity: 0;
  }

  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slide-out-left {
  from {
    transform: translateX(0px);
    opacity: 1;
  }

  to {
    transform: translateX(-20%);
    opacity: 0;
  }
}
</style>
